import { useEffect } from 'react';
import { connect, type FormikContextType } from 'formik';

const ErrorFocus = ({ formik }: { formik: FormikContextType<unknown> }) => {
  useEffect(() => {
    const { isSubmitting, isValidating, errors } = formik;
    const keys = Object.keys(errors);

    if (keys.length > 0 && isSubmitting && !isValidating) {
      const selector = `[id="${keys[0]}"], [name="${keys[0]}"]`;
      const errorElement = document.querySelector(selector);
      if (errorElement) {
        // 300px above the field, as react-scroll's animateScroll.scrollTo() did (the browser animates it now).
        const coordinates = errorElement.getBoundingClientRect();
        window.scrollTo({ top: coordinates.top + window.scrollY - 300, behavior: 'smooth' });
      }
    }
  }, [formik]);
  return null;
};

export default connect<Record<string, never>, unknown>(ErrorFocus);
